// Imports
import { Component, OnInit } from '@angular/core';
import { Constant } from "../../constant";
import { DataService } from '../../service/data.service';
import { DomSanitizer } from '@angular/platform-browser';

// Component Decorator
@Component({
  selector: 'notFound',
  templateUrl: './notFound.html',
  styleUrls: ['./notFound.scss']
})

// Component Class
export class NotFoundComponent implements OnInit {
  public Constant = Constant;
  constructor(
      public dataService: DataService,
      public sanitizer:DomSanitizer,
  ) {

  }
  ngOnInit() {
    this.initData();
  }
  initData() {
    
  }
  sanitize(url:string){
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}